var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25708,
    cy: 7.5,
    r: 7.5,
    fill: "#FF5656"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5991 4.72513L11.5991 4.72512C11.7556 4.56853 11.7556 4.31479 11.5991 4.15827C11.4425 4.00175 11.1888 4.00175 11.0323 4.15827L4.91565 10.2747C4.75916 10.4312 4.75914 10.6849 4.91559 10.8414C4.99366 10.9201 5.09642 10.9591 5.19888 10.9591C5.30146 10.9591 5.40405 10.9195 5.48242 10.8416L5.48253 10.8415L11.5991 4.72513Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91564 4.72512L4.91566 4.72513L11.0326 10.8414C11.0326 10.8414 11.0326 10.8414 11.0327 10.8415C11.1108 10.9201 11.2135 10.9591 11.3159 10.9591C11.4181 10.9591 11.5206 10.9195 11.5989 10.8416L11.5991 10.8415C11.7556 10.685 11.7556 10.4312 11.5991 10.2747L5.48253 4.15827L5.48252 4.15825C5.32592 4.00176 5.07218 4.00175 4.91565 4.15827C4.75913 4.31479 4.75915 4.56853 4.91564 4.72512Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.42dbf55b.svg";
export { ForwardRef as ReactComponent };